import { WelcomeWidget } from '~/components/widget/WelcomeWidget';
import { EvaluationWidget } from '~/components/widget/EvaluationWidget';
import { PropertyInformationWidget } from '~/components/widget/PropertyInformationWidget';
import type { Widget } from '@agentselly/model';
import { PriceDevelopmentWidget } from '~/components/widget/PriceDevelopmentWidget';
import { BlogWidget } from '~/components/widget/BlogWidget';
import { OfferWidget } from '~/components/widget/OfferWidget';
import { Space, WrapperWidget } from '@agentselly/ui';
import { NewPropertyWidget } from '~/components/widget/NewPropertyWidget';
import { SearchProfileWidget } from '~/components/widget/SearchProfileWidget';
import { PropertyProgressWidget } from '~/components/widget/PropertyProgressWidget';
import { MarketInterestWidget } from '~/components/widget/MarketInterestWidget';
import { MarketDynamicWidget } from '~/components/widget/MarketDynamicWidget';
import {
  IframeWidget,
  MapIframeWidget,
} from '~/components/widget/IframeWidget';
import { NearObjectsWidget } from '~/components/widget/NearObjectsWidget';
import type { WidgetConfigEntry } from '@agentselly/immodossier-shared';
import { DetailedEvaluationWidget } from '~/components/widget/DetailedEvaulationWidget';
import { EvaluationScoreWidget } from '~/components/widget/EvaluationScoreWidget';
import { EvaluationSubscriptionsWidget } from '~/components/widget/EvaluationSubscriptionsWidget';
import { EvaluationContactWidget } from '~/components/widget/EvaluationContactWidget';
import { PropertyQualityWidget } from '~/components/widget/PropertyQualityWidget';
import { MyEnergyGuideWidget } from '~/components/widget/MyEnergyGuideWidget';
import { PropertyConditionsWidget } from '~/components/widget/PropertyConditionsWidget';
import { MarketEvolutionBarWidget } from '~/components/widget/MarketEvolutionBarWidget';
import { ContactPhoneWidget } from '~/components/widget/ContactPhoneWidget';
import { ContactFormWidget } from '~/components/widget/ContactFormWidget';
import { PropertyFormWidget } from '~/components/widget/PropertyFormWidget';
import { DeleteDossierWidget } from '~/components/widget/DeleteDossierWidget';
import { PropertyConditionsQualityFormWidget } from '~/components/widget/PropertyConditionsQualityFormWidget';
import { ProfileFormWidget } from '~/components/widget/ProfileFormWidget';
import { CockpitWelcomeWidget } from '~/components/widget/cockpit/CockpitWelcomeWidget';
import { CockpitExposeWidget } from '~/components/widget/cockpit/CockpitExposeWidget';
import { CockpitActivitiesWidget } from '~/components/widget/cockpit/CockpitActivitiesWidget';
import { CockpitAdvertisementWidget } from '~/components/widget/cockpit/CockpitAdvertisementWidget';
import { CockpitNumericValueWidget } from '~/components/widget/cockpit/CockpitNumericValueWidget';
import { CockpitMarketingWidget } from '~/components/widget/cockpit/CockpitMarketingWidget';
import { CockpitLostInterestWidget } from '~/components/widget/cockpit/CockpitLostInterestWidget';
import { CockpitInterestedBuyersDetailWidget } from '~/components/widget/cockpit/CockpitInterestedBuyersDetailWidget';
import { CockpitRejectionReasonsGraphWidget } from '~/components/widget/cockpit/CockpitRejectionReasonsGraphWidget';
import { CockpitContractWidget } from '~/components/widget/cockpit/CockpitContractWidget';
import { CockpitSummaryWidget } from '~/components/widget/cockpit/CockpitSummaryWidget';
import { CockpitInternalExternalAgentWidget } from '~/components/widget/cockpit/CockpitInternalExternalAgentWidget';
import { CockpitOffersInDetailWidget } from '~/components/widget/cockpit/CockpitOffersInDetailWidget';
import { CockpitOffersDetailWidget } from '~/components/widget/cockpit/CockpitOffersDetailWidget';
import { CockpitOffersTrendWidget } from '~/components/widget/cockpit/CockpitOffersTrendWidget';
import { CockpitSalesStageWidget } from '~/components/widget/cockpit/CockpitSalesStageWidget';
import { CockpitCalendarEventDetailWidget } from '~/components/widget/cockpit/CockpitCalendarEventDetailWidget';
import { CockpitCalendarEventWidget } from '~/components/widget/cockpit/CockpitCalendarEventWidget';
import { CockpitStatisticsDetailWidget } from '~/components/widget/cockpit/CockpitStatisticsDetailWidget';

import { CockpitActivitiesDetailWidget } from '~/components/widget/cockpit/CockpitActivitiesDetailWidget';
import { CockpitEvaluationTrendWidget } from '~/components/widget/cockpit/CockpitEvaluationTrendWidget';
import { StatisticsRangeProvider } from '~/context/StatisticsRangeContext';
import { useEffect, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { EmptyState } from '~/components/empty/EmptyState';
import { Icon } from '~/components/Icon';
import { HubspotFormWidget } from '~/components/widget/HubspotFormWidget';
import { HeroCTAWidget } from '~/components/widget/HeroCTAWidget';
import { ClerkProfileWidget } from '~/components/widget/ClerkProfileWidget';
import { ClerkLoginWidget } from '~/components/widget/ClerkLoginWidget';
import { ClerkRegisterWidget } from '~/components/widget/ClerkRegisterWidget';
import { ClerkWaitlistWidget } from '~/components/widget/ClerkWaitlistWidget';
import { ExposeViewWidget } from './ExposeViewWidget';
import { VisitBookingWidgetGate as VisitBookingWidget } from './VisitBookingWidgetGate';
import { PartnerEnergyCostWidget } from '~/components/widget/partner/PartnerEnergyCostWidget.tsx';
import { PartnerTitleWidget } from '~/components/widget/partner/PartnerTitleWidget.tsx';
import { PartnerEnergyDemandWidget } from '~/components/widget/partner/PartnerEnergyDemandWidget.tsx';
import { PartnerEnergyEmissionsWidget } from '~/components/widget/partner/PartnerEnergyEmissionsWidget.tsx';
import { PartnerEvaluationMapWidget } from '~/components/widget/partner/PartnerEvaluationMapWidget.tsx';
import { PartnerEvaluationValueWidget } from '~/components/widget/partner/PartnerEvaluationValueWidget.tsx';
import { PartnerMarketDemandWidget } from '~/components/widget/partner/PartnerMarketDemandWidget.tsx';
import { PartnerMarketOfferWidget } from '~/components/widget/partner/PartnerMarketOfferWidget.tsx';
import { PartnerNotImplementedWidget } from '~/components/widget/partner/PartnerNotImplementedWidget.tsx';
import { PartnerRegionPointsOfInterestWidget } from '~/components/widget/partner/PartnerRegionPointsOfInterestWidget.tsx';
import { PartnerSectionWidget } from '~/components/widget/partner/PartnerSectionWidget.tsx';
import { PartnerNavigationWidget } from '~/components/widget/partner/PartnerNavigationWidget.tsx';
import { PartnerWelcomeWidget } from '~/components/widget/partner/PartnerWelcomeWidget.tsx';
import { PartnerContentWidget } from '~/components/widget/partner/PartnerContentWidget.tsx';
import { PartnerConsultingWidget } from '~/components/widget/partner/PartnerConsultingWidget.tsx';
import { PartnerFrequentlyAskedQuestionsWidget } from '~/components/widget/partner/PartnerFrequentlyAskedQuestionsWidget.tsx';

import { CockpitDocumentsWidget } from '~/components/widget/cockpit/CockpitDocumentsWidget';
import { CockpitDocumentsDashboardWidget } from '~/components/widget/cockpit/CockpitDocumentsDashboardWidget';

interface Props {
  readonly showLoadingMessage?: boolean;
  readonly widgets: WidgetConfigEntry[];
  readonly sessionId?: string;
}

export function RenderWidgets(props: Props) {
  const { t } = useTranslate();

  const [
    isLoading,
    setIsLoading,
  ] = useState(false);

  const [
    showError,
    setShowError,
  ] = useState(false);

  useEffect(() => {
    const errorTimer = setTimeout(() => {
      if (isLoading) {
        setShowError(true);
      }
    }, 60000);

    return () => {
      clearTimeout(errorTimer);
    };
  }, [isLoading]);

  useEffect(() => {
    setIsLoading(Boolean(props.showLoadingMessage));
  }, [
    props.showLoadingMessage,
  ]);

  return (
    <div className="relative">
      {(props.showLoadingMessage || showError) && (
        <>
          {/* Backdrop */}
          <div className="fixed inset-0 bg-black/5 backdrop-blur-[2px] z-[99999] transition-all duration-300" />
          {/* Modal */}
          <div className="fixed inset-0 flex items-start justify-center z-[999999] pointer-events-none">
            <div className="bg-white dark:bg-gray-800/95 p-6 rounded-xl shadow-lg dark:shadow-gray-900/50 mt-24 pointer-events-auto max-w-md mx-4 border border-slate-200 dark:border-slate-700/60 dark:border-gray-700/60 backdrop-blur transition-all duration-300">
              {props.showLoadingMessage && !showError && (
                <div className="space-y-5">
                  <div className="flex items-center gap-4">
                    <div className="rounded-full flex items-center justify-center">
                      <div role="status">
                        <svg
                          aria-hidden="true"
                          className="w-12 h-12 animate-spin text-primary-400 fill-primary-50"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          />
                        </svg>
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                    <p className="text-slate-700 dark:text-slate-300 font-medium">
                      {t('evaluation_result_loading')}
                    </p>
                  </div>
                </div>
              )}

              {showError && (
                <div className="space-y-4">
                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 rounded-full bg-red-100 flex-shrink-0 flex items-center justify-center">
                      <Icon
                        icon="warning"
                        className="h-5 w-5 text-red-600"
                      />
                    </div>
                    <div className="space-y-3 flex-1">
                      <p className="text-slate-700 dark:text-slate-300">
                        {t('evaluation_result_timeout_prefix')}
                      </p>
                      <a
                        href="mailto:support@agentselly.ch"
                        className="text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-2 group"
                      >
                        <span className="underline underline-offset-4">
                          support@agentselly.ch
                        </span>
                      </a>
                      <p className="text-slate-600 dark:text-slate-400">
                        {t('evaluation_result_timeout_postfix')}
                      </p>
                      <div className="bg-slate-50 dark:bg-slate-800 dark:bg-gray-900 p-3 rounded-lg border border-slate-200 dark:border-slate-700 dark:border-gray-700">
                        <code className="font-mono text-sm text-slate-700 dark:text-slate-300">
                          {props?.sessionId || '-'}
                        </code>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {/* Keep a single provider wrapping the grid */}
      <StatisticsRangeProvider>
        <div className="grid grid-cols-1 xl:grid-cols-12 gap-4 mb-20">
          {props.widgets.map((widget, idx) => {
            const widgetContent = (
              <RenderWidget
                key={idx}
                config={widget}
              />
            );

            if (widgetContent === null) {
              return null;
            }

            // Map cols to Tailwind classes (1-12)
            const getColsClass = (cols?: number) => {
              const colMap: Record<number, string> = {
                1: 'xl:col-span-1',
                2: 'xl:col-span-2',
                3: 'xl:col-span-3',
                4: 'xl:col-span-4',
                5: 'xl:col-span-5',
                6: 'xl:col-span-6',
                7: 'xl:col-span-7',
                8: 'xl:col-span-8',
                9: 'xl:col-span-9',
                10: 'xl:col-span-10',
                11: 'xl:col-span-11',
                12: 'xl:col-span-12',
              };
              return cols && colMap[cols] ? colMap[cols] : 'xl:col-span-6';
            };

            return (
              <div
                key={idx}
                id={widget.name}
                className={`widget-auto-card w-full ${getColsClass(
                  widget.cols,
                )}`}
                data-widget={widget.name}
              >
                {widgetContent}
              </div>
            );
          })}
        </div>
      </StatisticsRangeProvider>
    </div>
  );
}

interface RenderWidgetProps {
  readonly config: WidgetConfigEntry;
}

function RenderWidget(props: RenderWidgetProps) {
  const config = props.config;

  const widget = widgets[config.name];

  if (!widget) {
    throw new Error(`Widget ${config.name} not found`);
  }

  const Widget = widget.component;

  const widgetProps = {
    ...(config.props || {}),
  };

  // If hidden is explicitly set, skip rendering entirely (no EmptyState)
  if (widgetProps.hidden === true) {
    return null;
  }

  // If the widget returns null, we don't render it to not break the layout
  const { t } = useTranslate();
  if (Widget(widgetProps) === null) {
    return (
      <WrapperWidget>
        <EmptyState
          title={t('empty_no_data_title') || 'Noch keine Daten'}
          description={
            t('empty_no_data_description') ||
            'Sobald Daten vorhanden sind, erscheinen hier Inhalte.'
          }
        />
      </WrapperWidget>
    );
  }

  return <Widget {...widgetProps} />;
}

const widgets: Record<string, Widget> = {
  welcome: {
    component: WelcomeWidget,
  },
  evaluation: {
    component: EvaluationWidget,
  },
  evaluationPropertyInformation: {
    component: PropertyInformationWidget,
  },
  evaluationPriceDevelopment: {
    component: PriceDevelopmentWidget,
  },
  blog: {
    component: BlogWidget,
  },
  offer: {
    component: OfferWidget,
  },
  space: {
    component: Space,
  },
  newProperty: {
    component: NewPropertyWidget,
  },
  searchProfile: {
    component: SearchProfileWidget,
  },
  propertyProgress: {
    component: PropertyProgressWidget,
  },
  marketInterest: {
    component: MarketInterestWidget,
  },
  marketDynamic: {
    component: MarketDynamicWidget,
  },
  priceHubbleMap: {
    component: MapIframeWidget,
  },
  nearObjects: {
    component: NearObjectsWidget,
  },
  evaluationDetailedEvaluation: {
    component: DetailedEvaluationWidget,
  },
  evaluationScore: {
    component: EvaluationScoreWidget,
  },
  evaluationSubscriptions: {
    component: EvaluationSubscriptionsWidget,
  },
  evaluationContact: {
    component: EvaluationContactWidget,
  },
  evaluationPropertyQuality: {
    component: PropertyQualityWidget,
  },
  evaluationMyEnergyGuide: {
    component: MyEnergyGuideWidget,
  },
  evaluationPropertyConditions: {
    component: PropertyConditionsWidget,
  },
  evaluationHouseRemodellingManager: {
    component: IframeWidget,
  },
  marketEvolutionBar: {
    component: MarketEvolutionBarWidget,
  },
  contactPagePhone: {
    component: ContactPhoneWidget,
  },
  contactPageForm: {
    component: ContactFormWidget,
  },
  propertyForm: {
    component: PropertyFormWidget,
  },
  propertyConditionQualityForm: {
    component: PropertyConditionsQualityFormWidget,
  },
  dossierDelete: {
    component: DeleteDossierWidget,
  },
  profileForm: {
    component: ProfileFormWidget,
  },
  clerkProfile: {
    component: ClerkProfileWidget,
  },
  clerkLogin: {
    component: ClerkLoginWidget,
  },
  clerkRegister: {
    component: ClerkRegisterWidget,
  },
  clerkWaitlist: {
    component: ClerkWaitlistWidget,
  },
  // Cockpit widgets
  cockpitWelcome: {
    component: CockpitWelcomeWidget,
  },
  cockpitExpose: {
    component: CockpitExposeWidget,
  },
  cockpitAdViews: {
    component: CockpitAdvertisementWidget,
  },
  cockpitDigitalTour: {
    component: CockpitNumericValueWidget,
  },
  cockpitExposeDownloads: {
    component: CockpitNumericValueWidget,
  },
  cockpitBookedVisits: {
    component: CockpitNumericValueWidget,
  },
  cockpitInterestedBuyers: {
    component: CockpitNumericValueWidget,
  },
  cockpitOffers: {
    component: CockpitNumericValueWidget,
  },
  cockpitActivities: {
    component: CockpitActivitiesWidget,
  },
  cockpitActivitiesDetail: {
    component: CockpitActivitiesDetailWidget,
  },
  cockpitMarketing: {
    component: CockpitMarketingWidget,
  },
  cockpitInterestLost: {
    component: CockpitLostInterestWidget,
  },
  cockpitContract: {
    component: CockpitContractWidget,
  },

  cockpitStatisticsAdViews: {
    component: CockpitStatisticsDetailWidget,
  },
  cockpitStatisticsDigitalTourViews: {
    component: CockpitStatisticsDetailWidget,
  },
  cockpitStatisticsExposeDownloadsViews: {
    component: CockpitStatisticsDetailWidget,
  },
  cockpitCalendarEventsWidget: {
    component: CockpitCalendarEventWidget,
  },
  cockpitCalendarEventsUpcomingWidget: {
    component: CockpitCalendarEventDetailWidget,
  },
  cockpitCalendarEventsPastWidget: {
    component: CockpitCalendarEventDetailWidget,
  },
  cockpitOffersDetailWidget: {
    component: CockpitOffersDetailWidget,
  },
  cockpitOffersInDetailWidget: {
    component: CockpitOffersInDetailWidget,
  },
  cockpitOffersTrendWidget: {
    component: CockpitOffersTrendWidget,
  },
  cockpitEvaluationTrendWidget: {
    component: CockpitEvaluationTrendWidget,
  },
  cockpitSalesStage: {
    component: CockpitSalesStageWidget,
  },
  cockpitInternalExternalAgentWidget: {
    component: CockpitInternalExternalAgentWidget,
  },
  cockpitSummaryWidget: {
    component: CockpitSummaryWidget,
  },
  cockpitLostInterestWidget: {
    component: CockpitLostInterestWidget,
  },
  cockpitInterestedBuyersDetailWidget: {
    component: CockpitInterestedBuyersDetailWidget,
  },
  cockpitRejectionReasonsGraphWidget: {
    component: CockpitRejectionReasonsGraphWidget,
  },
  cockpitDocumentsWidget: {
    component: CockpitDocumentsWidget,
  },
  cockpitDocuments: {
    component: CockpitDocumentsWidget,
  },
  cockpitDocumentsDashboard: {
    component: CockpitDocumentsDashboardWidget,
  },
  hubspotForm: {
    component: HubspotFormWidget,
  },
  heroCTAWidget: {
    component: HeroCTAWidget,
  },
  exposeViewWidget: {
    component: ExposeViewWidget,
  },
  visitBookingWidget: {
    component: VisitBookingWidget,
  },
  // Partner
  partnerNotImplemented: {
    component: PartnerNotImplementedWidget,
  },
  partnerSection: {
    component: PartnerSectionWidget,
  },
  partnerNavigation: {
    component: PartnerNavigationWidget,
  },
  partnerWelcome: {
    component: PartnerWelcomeWidget,
  },
  partnerTitle: {
    component: PartnerTitleWidget,
  },
  partnerEnergyCost: {
    component: PartnerEnergyCostWidget,
  },
  partnerEnergyDemand: {
    component: PartnerEnergyDemandWidget,
  },
  partnerEnergyEmissions: {
    component: PartnerEnergyEmissionsWidget,
  },
  partnerEvaluationMap: {
    component: PartnerEvaluationMapWidget,
  },
  partnerEvaluationValue: {
    component: PartnerEvaluationValueWidget,
  },
  partnerMarketDemand: {
    component: PartnerMarketDemandWidget,
  },
  partnerMarketOffer: {
    component: PartnerMarketOfferWidget,
  },
  partnerRegionPointsOfInterest: {
    component: PartnerRegionPointsOfInterestWidget,
  },
  partnerContent: {
    component: PartnerContentWidget,
  },
  partnerConsulting: {
    component: PartnerConsultingWidget,
  },
  partnerFrequentlyAskedQuestions: {
    component: PartnerFrequentlyAskedQuestionsWidget,
  },
};
